import { Fragment } from "react";
import cls from "classnames";
import { Space, Divider, Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import ArcticIconFont from "@/icon";

function RouteItem({ item, active }) {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className={cls("item", { current: item.current })}>
        <div className="thumbnail">
          <ArcticIconFont type="icon-lujing" />
        </div>
        <div className="content">
          <div className="title" onClick={(e) => active(item.id)}>
            {item.name}
          </div>
          <div className="meta">
            <Space>
              <div>
                <ArcticIconFont type="icon-changdu" />
                {item.economy?.l}
                {t("km")}
              </div>
              <div>
                <ArcticIconFont type="icon-shichang" /> {t("timeEstimating")}
                {item.economy?.d}
                {t("day")}
              </div>
              <div>
                <ArcticIconFont type="icon-oil" /> {t("oil")} {item.economy?.f}
                {t("tons")}
              </div>
            </Space>
          </div>
          <div className="economy">
            <Descriptions
              size="small"
              bordered
              column={1}
              labelStyle={{
                color: "#fff",
                backgroundColor: "transparent",
                width: 200,
                padding: 5,
              }}
              contentStyle={{ color: "rgba(255, 255, 255, 0.65)", padding: 8 }}
            >
              <Descriptions.Item label={t("n")}>
                {item.economy?.n}
              </Descriptions.Item>
              <Descriptions.Item label={t("eco2")}>
                {item.economy?.eco2}
              </Descriptions.Item>
              <Descriptions.Item label={t("aer")}>
                {item.economy?.aer}
              </Descriptions.Item>
              <Descriptions.Item label={t("aeco2")}>
                {item.economy?.aeco2}
              </Descriptions.Item>
              <Descriptions.Item label={t("cvc")}>
                {item.economy?.cvc}
              </Descriptions.Item>
              <Descriptions.Item label={t("acvc")}>
                {item.economy?.acvc}
              </Descriptions.Item>
              <Descriptions.Item label={t("apvp")}>
                {item.economy?.apvp}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>
      </div>
      <Divider />
    </Fragment>
  );
}

export default RouteItem;
